import { AmbivalentFactorEffectCategoryEnum } from '@dermloop/static-values';
import { IsEnum, IsNotEmpty } from 'class-validator';
import { NamedEntityDto } from './named.dto';

export class AmbivalentFactorDto extends NamedEntityDto {
  @IsNotEmpty()
  @IsEnum(AmbivalentFactorEffectCategoryEnum)
  effectCategory: AmbivalentFactorEffectCategoryEnum;
}
